export const DELETE_BUTTON_TEXT = "Delete";
export const RESET_BUTTON = "Reset";
export const CANCEL_BUTTON = "Cancel";
export const SAVE_BUTTON = "Save";
export const COPY_TO_NEW_BUTTON = "Copy to New";
